import { useEffect, useState } from 'react';

const pad = (n) => String(n).padStart(2, '0');

export const CountdownTimer = ({ endsAt, className = '', onEnd, labelPrefix = '' }) => {
    const [now, setNow] = useState(() => new Date());
    const end = endsAt ? new Date(endsAt) : null;
    const isValid = end && !isNaN(end.getTime());
    const diff = isValid ? Math.max(0, Math.floor((end.getTime() - now.getTime()) / 1000)) : 0;

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    useEffect(() => {
        if (!isValid) return;
        if (diff === 0 && onEnd) onEnd();
    }, [diff, isValid, onEnd]);

    if (!isValid) return <span className={className}>—</span>;
    if (diff === 0) return <span className={`text-red-600 font-semibold ${className}`}>Finalizado</span>;

    const d = Math.floor(diff / 86400);
    const h = Math.floor((diff % 86400) / 3600);
    const m = Math.floor((diff % 3600) / 60);
    const s = diff % 60;
    return (
        <span className={`font-mono tabular-nums ${className}`} data-testid="countdown-timer">
            {labelPrefix}{d > 0 ? `${d}d ` : ''}{pad(h)}:{pad(m)}:{pad(s)}
        </span>
    );
};
